<template>
  <div>
    <PageHeader :title="update ? 'ویرایش اطلاعات دانش پذیر' : 'اضافه کردن دانش پذیر'" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="inner__style">
          <div
            v-if="model.image.length === 0"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="(event) => (this.model.image.length ? event.preventDefault() : $refs.fileInput.click())"
          >
            <div>
              <i :class="['fas fa-cloud-upload-alt icon-size', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>
              <div class="upload-text-size">برای آپلود عکس خود کلیک کنید</div>
            </div>
            <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInput" />
          </div>
          <div v-else class="grand-parent">
            <div class="upload-photo-parent">
              <div class="uploaded-photo">
                <div class="remove-icon" @click="model.image = ''">
                  <i class="fa fa-times"></i>
                </div>
                <img class="previewImage" :src="model.image" />
              </div>
            </div>
          </div>
          <div class="my-3">
            <TextAreaInput rows="2" :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین" placeholder="متن جایگزین" />
          </div>
        </div>
        <div class="card p-3 mt-3 my-auto d-flex flex-row justify-content-between">
          <b-form-checkbox v-model="model.isEnable" class="pt-2">
            <div class="mx-1">نمایش دانش پذیر</div>
          </b-form-checkbox>
          <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary" :disabled="cantEdit">
            <i class="far fa-times-circle"></i>
            <span class="ms-2">حذف دانش پذیر</span>
          </b-button>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card">
          <Section title="اطلاعات فردی">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.firstName" @input="model.firstName = $event" title="نام" placeholder="نام" />
            </div>
            <div>
              <BaseText :maxlength="2000" :value="model.lastName" @input="model.lastName = $event" title="نام خانوادگی" placeholder="نام خانوادگی" />
            </div>
          </Section>
          <Section title="چه می گوید">
            <TextAreaInput :value="model.description" @input="model.description = $event" title="توضیحات" />
          </Section>
        </div>
        <!-- <div class="card">
          <Section title="تنظیمات سئو">
            <div class="my-3">
              <Tags title="کلیدواژه" :value="model.seoKeyword" classes="tags" @input="model.seoKeyword = $event" placeholder="کلیدواژه" />
            </div>

            <div class="my-3">
              <TextAreaInput :value="model.seoDescription" @input="model.seoDescription = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>

            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.seoUrlDescription" @input="model.seoUrlDescription = $event" title="متن URL" placeholder="متن URL" />
            </div>
          </Section>
        </div> -->
        <div class="card p-3 d-flex flex-row justify-content-end">
          <b-button @click="$router.go(-1)">انصراف</b-button>
          <b-button variant="primary ms-2 px-5" @click="addStudent" :disabled="cantEdit">ثبت</b-button>
        </div>
      </b-col>
    </b-row>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف دانش پذیر اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deleteStudent">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
  </div>
</template>
<script>
import PageHeader from '../../layoutComponents/page-header.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import fileMannager from '../../../services/file'
import skillUpStudentProvider from '../../../services/skillUp/student'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import Section from '../../common/form/Section.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
export default {
  name: 'AddStudent',
  components: { PageHeader, BaseText, Toast, Loader, Section, TextAreaInput },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        firstName: '',
        lastName: '',
        description: '',
        image: '',
        isEnable: true,
        imageAlternateText: '',
        imageDescription: '',
        productId: 0,
      },
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      loading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دانش پذیر', active: true },
      ],
      cantEdit: false,
    }
  },
  computed: {
    productType() {
      const route = this.$route.path
      if (route.includes('carrier')) {
        return 'Carrier'
      } else if (route.includes('course')) {
        return 'Course'
      } else if (route.includes('package')) {
        return 'Package'
      } else if (route.includes('home')) {
        return 'Home'
      }
      return ''
    },
  },
  mounted() {
    setTimeout(() => {
      this.cantEdit =
        (this.$route.path.includes('faculty') || this.$route.path.includes('support') || this.$route.path.includes('agent')) &&
        (localStorage.getItem('productStatus') == 4 || localStorage.getItem('productStatus') == 3)
    }, 500)
    if (this.update) {
      this.fetchStudent()
      this.model = this.data
    }
    const product = localStorage.getItem('course') || localStorage.getItem('package')
    if (product) {
      this.model.productId = +product
    } else if (this.model.productId === 0) delete this.model.productId
  },
  methods: {
    onFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        this.uploadImage(e.target.result)
      }

      reader.readAsDataURL(file)
    },
    async addStudent() {
      this.loading = true
      try {
        if (this.update) {
          const req = await skillUpStudentProvider.updateStudent(this.model)
          if (req.status === 200) {
            this.message = 'ثبت با موفقیت انجام شد.'
            setTimeout(() => {
              this.message = ''
            }, 5000)
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          this.loading = false
          return false
        }
        const req = await skillUpStudentProvider.addStudent(this.model, this.productType)
        if (req.status === 200) {
          this.message = 'ثبت با موفقیت انجام شد.'
          setTimeout(() => {
            this.$router.go(-1)
          }, 2000)
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchStudent() {
      this.loading = true
      try {
        const req = await skillUpStudentProvider.getStudent(+this.$route.params.id)
        this.model = req.data.data.output
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchStudentCategories() {
      this.loading = true
      try {
        const req = await skillUpStudentProvider.getStudentCategory()
        req.data.data.output.forEach((item) => {
          this.studentCategories.push({ value: item.title, key: item.id })
        })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.model.image = req.data.data.downloadUrl
      this.cropperLoading = false
    },
    async deleteStudent() {
      this.loading = true
      try {
        const req = await skillUpStudentProvider.deleteStudent(+this.$route.params.id)
        this.$bvModal.hide('deleteModal')
        if (req.status === 200) {
          this.$router.go(-1)
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.sections {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 1rem;
}

.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  height: 122px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}
.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
}

::v-deep .b-form-tags-button {
  display: none;
}

.disable {
  pointer-events: none;
  opacity: 0.5;
}
</style>
